import { isElectronMode } from 'src/config'
import Model from 'src/models/model'

/**
 * @param {import('@quasar/app-webpack').BootFileParams} params
 */
export default async ({ app }) => {
  if (!isElectronMode) return

  if (app.config.globalProperties.$remoteCommands) {
    const remoteCommands = app.config.globalProperties.$remoteCommands
    remoteCommands.handlePrintData = function (data) {
      return handlePrint(data.receipt_commands)
    }
  }

  if (app.config.globalProperties.$printTransactionsCommands) {
    const printTransactionsCommands = app.config.globalProperties.$printTransactionsCommands
    printTransactionsCommands.handlePrintData = function (data) {
      return handlePrint(data.receipt_commands)
    }
  }

  const printHandler = {}

  function handlePrint (data) {
    const shouldOpenCashDrawer = _.last(_.flatten(data)) === 'openCashDrawer'
    const useOposCashDrawer = shouldOpenCashDrawer && Model.context?.currentRegisterClient?.registerStation?.isOposCashdrawerEnabled
    if (useOposCashDrawer) {
      console.log(Model.context?.currentRegisterClient?.registerStation?.openCashDrawer())
    }

    if (window.electronPrinter.printWithWidth) {
      const receiptPaperWidth = Model.context?.currentRegisterClient?.registerStation?.electronReceiptPaperWidth || Model.context?.currentKdsClient?.kitchenDisplay?.receiptPaperWidth || 576

      return window.electronPrinter.printWithWidth(data, receiptPaperWidth)
    }

    return window.electronPrinter.print(data)
  }

  app.config.globalProperties.$printHandler = printHandler
}
